import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate} from 'react-router-dom';
import httpService  from '../../api/httpService';
import AlertModal from '../commonComponents/AlertModal';

function UserForm({isEditing, toggleHandleDropdown,  openDropdown, getDropdownRef}) {

  const { userid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const[isPageLoading, setIsPageLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstname: '',
    lastname: '',
    middlename: '',
    // email: '',
    loginid: '',
    password: '',
    orgId: 0,
    admin: 0,
    status: 1
  })
  const [error, setError] = useState({});
  const [insertedId, setInsertedId] = useState(null);
  const [responseError, setResponseError] = useState(null);

  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertError, setAlertError] = useState(false);

  const [organizations, setOrganizations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  // const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const organizationDropdownRef = getDropdownRef("organization-dropdown");
  const [showChangePassword, setShowChangePassword] = useState(false);
  const[isNavigate, setIsNavigate] = useState(false);

// <----- to handle input data in the form ----->
  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
     if (name === "loginid") {
      // remove all spaces automatically
      const noSpaceValue = value.replace(/\s/g, "");
      setUserDetails(prevDetails => ({
        ...prevDetails,
        [name]: noSpaceValue
      }));
    } else if (type === 'checkbox') {
      setUserDetails(prevDetails => ({ ...prevDetails, [name]: e.target.checked ? 1 : 0 }));
    } else if (name === "status") {
      setUserDetails(prevDetails => ({
        ...prevDetails,
        [name]: Number(value)
      }));
    }else {
      setUserDetails(prevDetails => ({ ...prevDetails, [name]: value }));
    }
    if (error[name]) {
      setError((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    }
  };

// <----- fetching details for organization list -----> 
  const fetchOrganizations = async() =>{
    const result = await httpService.getData('/Organization/organization');
    if(result.isSuccess){ 
        setOrganizations(result.retObject);
    }     
  }  

  const filteredOrganizations = organizations.filter(org =>
    org.orgname.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelectOrganization = (id, name) => {
    // setSelectedOrganization(name);
    setSelectedOrganization({ orgid: id, orgname: name });
    setSearchQuery(''); 
    setUserDetails(prevState => ({
      ...prevState,
      orgId: id,
    }));  
    setError((prevErrors) => ({
      ...prevErrors,
      orgName: undefined
    }));
    toggleHandleDropdown("organization-dropdown"); 
  }

  useEffect(() => {
    fetchOrganizations();
  }, []);

// <----- fetching details for edit page ----->   
  useEffect(() => {
      if (isEditing) {
          const fetchData = async () => {
              setIsPageLoading(true);
              try{
                  const result = await httpService.getData(`/User/${userid}`);
                  const user = result.retObject;
                  // API returns C# model properties with PascalCase (e.g. Status, Admin, OrgId),
                  // but the form uses camelCase (status, admin, orgId). Avoid spreading `user`
                  // to prevent sending both PascalCase and camelCase keys in the payload.
                  const normalizedStatus = Number(user.status ?? user.Status ?? 1);
                  const normalizedAdminRaw = user.admin ?? user.Admin ?? 0;
                  const normalizedAdmin = normalizedAdminRaw === true ? 1 : (normalizedAdminRaw === false ? 0 : Number(normalizedAdminRaw));
                  const normalizedOrgId = user.orgId ?? user.OrgId ?? user.Orgid ?? 0;

                  setUserDetails({
                    firstname: user.firstname ?? user.Firstname ?? '',
                    lastname: user.lastname ?? user.Lastname ?? '',
                    middlename: user.middlename ?? user.Middlename ?? '',
                    loginid: user.loginid ?? user.Loginid ?? '',
                    password: '',
                    orgId: normalizedOrgId,
                    admin: normalizedAdmin || 0,
                    status: normalizedStatus || 0,
                  });
                  setShowChangePassword(false);
                  const orgId = user.orgId ?? user.OrgId ?? user.Orgid;
                  if (user.organization && (user.organization.orgid != null || user.organization.orgname != null)) {
                    setSelectedOrganization({
                      orgid: user.organization.orgid ?? orgId,
                      orgname: user.organization.orgname || user.organization.orgName || ''
                    });
                  } else if (orgId != null) {
                    setSelectedOrganization({ orgid: orgId, orgname: '' });
                  } else {
                    setSelectedOrganization(null);
                  }
              }catch(err){
                  setAlertMessage("Error in fetching data!");
                  setAlertError(true);
                  setIsAlertModalOpen(true);
              }finally {
                  setIsPageLoading(false);
              }
          }
          fetchData();
      } else {
          setIsPageLoading(false);
      }
  }, [isEditing, userid]);

  // Resolve organization name for edit when organizations list is loaded
  useEffect(() => {
    if (!isEditing || !organizations.length) return;
    const orgId = userDetails.orgId;
    if (orgId == null) return;
    if (selectedOrganization && selectedOrganization.orgname) return;
    const org = organizations.find((o) => Number(o.orgid) === Number(orgId));
    if (org) setSelectedOrganization({ orgid: org.orgid, orgname: org.orgname || org.orgName || '' });
  }, [isEditing, userDetails.orgId, organizations]);

// <----- to validate the form details ----->
  const validateFormData = () => {
    const errors = {};
    if (!userDetails.firstname) errors.firstname = "First Name is required.";
    // if (!userDetails.email) errors.email = "Email is required.";
    if (!userDetails.loginid) errors.loginid = "loginid is required.";
    if (!isEditing && !userDetails.password) errors.password = "Password is required.";
    if (isEditing && showChangePassword && !userDetails.password) errors.password = "Password is required.";
    if (!userDetails.lastname) errors.lastname = "Last Name is required.";
    if (!userDetails.admin && !userDetails.orgId) {
      errors.orgName = "Registry name is required.";
    }
    // if((userDetails.admin === 0) && (!userDetails.orgId) && !selectedOrganization.orgName) errors.orgName = "Registry name is required";
    return errors;
  }

// <----- to handle form detail submission ----->
  const handleFormSubmission = async (e) => {
    e.preventDefault();
    const detailError = validateFormData();
    setError(detailError);
    if (Object.keys(detailError).length > 0) {
      return;     
    }
    try{
      setLoading(true);
      const adminValue = userDetails.admin === 1 || userDetails.admin === true;
      // Use logged-in user as `AddedBy` (from localStorage)
      let addedByValue = "";
      try {
        const stored = localStorage.getItem("userDetails");
        const u = stored ? JSON.parse(stored) : null;
        addedByValue = u?.loginid ?? u?.Loginid ?? addedByValue;
      } catch {
        // Keep default "ABC"
      }

      // Send only API-expected (C# model) fields to avoid PascalCase/camelCase mismatches.
      const basePayload = {
        Firstname: userDetails.firstname,
        Lastname: userDetails.lastname,
        Loginid: userDetails.loginid,
        OrgId: Number(userDetails.orgId ?? userDetails.OrgId ?? 0),
        Admin: adminValue,
        Status: Number(userDetails.status ?? userDetails.Status ?? 0),
        AddedBy: addedByValue,
      };

      const payload = isEditing
        ? (() => {
            const apiPayload = { ...basePayload };
            if (showChangePassword) apiPayload.Password = userDetails.password;
            return apiPayload;
          })()
        : {
            ...basePayload,
            Password: userDetails.password,
          };

      console.log("Payload : ", payload);
      //return;
      if (isEditing) {
        const result = await httpService.putData(`/User/${userid}`, payload);
        if(result.isSuccess){
          //setInsertedId(result.retObject.insertedId ?? null);
          setIsNavigate(true);
          setAlertMessage("User detail updated successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
          if (showChangePassword) {
            setShowChangePassword(false);
            setUserDetails(prev => ({ ...prev, password: '' }));
          }
        }else{
          setResponseError(result.message);
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }else{
        const result = await httpService.postData('/User', payload);
        if(result.isSuccess){
          //setInsertedId(result.retObject.insertedId ?? null);
          setIsNavigate(true);
          setAlertMessage("User added successfully !");
          setAlertError(false);
          setIsAlertModalOpen(true);
        }else{
          setResponseError(result.message);
          setAlertMessage(result.message);
          setAlertError(true);
          setIsAlertModalOpen(true);
        }
      }
    }catch(error){
      console.error('Failed:', error);
      setAlertMessage("Error occured during detail submission !");
      setAlertError(true);
      setIsAlertModalOpen(true);
    }finally{
      setLoading(false);
    }  
  }

// <----- to handle alert close functionality ----->
  const handleCloseModal = () => {
    setIsAlertModalOpen(false);
    // if (!isEditing) {
    //   setUserDetails({
    //     firstname: '',
    //     lastname: '',
    //     middlename: '',
    //     email: '',
    //     loginid: '',
    //     password: '',
    //     orgId: 0,
    //     admin: 0
    //   });
    //   setSelectedOrganization(null);
    // }
    if(isNavigate){
      navigate('/user');
    }
  }

  return (
    <div className="app-content p-4">
      <div className="container-fluid mt-2">
        <div className="text-start mb-4">
            <Link to = "/user" className="back-icon">
                <i className="fa-solid fa-xl fa-circle-arrow-left"></i>
            </Link>
        </div>
        <div className="card custom-card create-user-card">
          <div className="card-header justify-content-between">
            <div className="card-title">{isEditing ? "Update User" : "Add User"}</div>
          </div>
          <div className="card-body">
            {isPageLoading ? (
              <div className="d-flex justify-content-center align-items-center loader-container">
                  <button className="btn btn-outline-secondary mt-3" type="button">
                      <span className="spinner-border spinner-border-sm align-middle me-2" role="status"
                        aria-hidden="true"></span>
                      Loading...
                  </button>
              </div>                                       
            ) : (
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3 row">
                      <label htmlFor="firstname" className="col-sm-4 col-form-label">First Name :</label>
                      <div className="col-sm-6">
                          <input type="text" className={`form-control ${error.firstname ? 'is-invalid' : ''}`}  name="firstname" id="firstname" value={userDetails.firstname} onChange={handleInputChange}/>
                          {error.firstname && (<div className="invalid-feedback">{error.firstname}</div>)}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label htmlFor="lastname" className="col-sm-4 col-form-label">Last Name :</label>
                      <div className="col-sm-6">
                          <input type="text" className={`form-control ${error.lastname ? 'is-invalid' : ''}`}  name="lastname" id="lastname" value={userDetails.lastname} onChange={handleInputChange}/>
                          {error.lastname && (<div className="invalid-feedback">{error.lastname}</div>)}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label htmlFor="loginid" className="col-sm-4 col-form-label">User Id :</label>
                      <div className="col-sm-6">
                          <input type="text" className={`form-control ${error.loginid ? 'is-invalid' : ''}`}  name="loginid" id="loginid" value={userDetails.loginid} onChange={handleInputChange}/>
                          {error.loginid && (<div className="invalid-feedback">{error.loginid}</div>)}
                      </div>
                    </div>
                    {!isEditing && (
                      <div className="mb-3 row">
                        <label htmlFor="password" className="col-sm-4 col-form-label">Password :</label>
                        <div className="col-sm-6">
                            <input type="password" className={`form-control ${error.password ? 'is-invalid' : ''}`}  name="password" id="password" value={userDetails.password} onChange={handleInputChange}/>
                            {error.password && (<div className="invalid-feedback">{error.password}</div>)}
                        </div>
                      </div>
                    )}
                    {isEditing && (
                      <div className="mb-3 row">
                        <label className="col-sm-4 col-form-label">
                          {!showChangePassword ? null : 'New password :'}
                        </label>
                        <div className="col-sm-6">
                          {!showChangePassword ? (
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setShowChangePassword(true)}>
                              Change password
                            </button>
                          ) : (
                            <>
                              <input type="password" className={`form-control ${error.password ? 'is-invalid' : ''}`} id="edit-password" name="password" value={userDetails.password} onChange={handleInputChange} placeholder="Enter new password"/>
                              {error.password && <div className="invalid-feedback d-block">{error.password}</div>}
                              <button type="button" className="btn btn-link btn-sm p-0 mt-1" onClick={() => { setShowChangePassword(false); setUserDetails(prev => ({ ...prev, password: '' })); setError(prev => ({ ...prev, password: undefined })); }}>Cancel</button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    {/* <div className="mb-3 row">
                      <label htmlFor="middlename" className="col-sm-4 col-form-label">Middle Name :</label>
                      <div className="col-sm-6">
                          <input type="text" className="form-control"  name="middlename" id="middlename" value={userDetails.middlename} onChange={handleInputChange}/>
                      </div>
                    </div> */}
                    {/* <div className="mb-3 row">
                      <label htmlFor="email" className="col-sm-4 col-form-label">Email :</label>
                      <div className="col-sm-6">
                          <input type="email" className={`form-control ${error.email ? 'is-invalid' : ''}`}  name="email" id="email" value={userDetails.email} onChange={handleInputChange}/>
                          {error.email && (<div className="invalid-feedback">{error.email}</div>)}
                      </div>
                    </div> */}
                    <div className="mb-3 row">
                      <label className="col-sm-4 col-form-label">Role :</label>
                      <div className="col-sm-6 d-flex align-items-center">
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" name="admin" id="admin"
                            checked={userDetails.admin === 1 || userDetails.admin === true}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="admin">ISAKOS Admin</label>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label htmlFor="organization" className="col-sm-4 col-form-label">Registry Name :</label>
                      <div className="col-sm-6">
                        {/* <select className="form-select" name="orgId" value={userDetails.orgId} onChange={handleInputChange}>
                            <option value="">Select</option>
                            <option value="1">Organization 1</option>
                            <option value="2">Organization 2</option>
                        </select> */}
                        <div className="dropdown-container" ref={organizationDropdownRef}>
                          <div className={`form-select box-content ${error.orgName ? 'is-invalid' : ''}`} onClick={(e) => { e.preventDefault(); toggleHandleDropdown("organization-dropdown"); }}>
                            {(selectedOrganization && (selectedOrganization.orgname ?? selectedOrganization.orgName)) || 'Select'}
                          </div>
                          {openDropdown && openDropdown === 'organization-dropdown' && (
                            <div className='drop-content'>
                              <input className='drop-content-input' type="text" 
                                placeholder="Search Registry" value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                              {filteredOrganizations.length > 0 ? (filteredOrganizations.map(org => (
                                <div key={org.orgid} className={`drop-option ${selectedOrganization && selectedOrganization.orgname  === org.orgname ? 'selected' : ''}`}
                                  onClick={() => handleSelectOrganization(org.orgid, org.orgname)}
                                >
                                  {selectedOrganization && selectedOrganization.orgname === org.orgname && <span className="tick-icon"><i className="fa-solid fa-check"></i></span>}
                                  {org.orgname}
                                </div>
                              ))) : (
                                <div className="drop-option">No data</div>
                              )}
                            </div>
                          )}
                        </div>
                        {error.orgName && (<div className="invalid-feedback" style={{display: 'block'}}>{error.orgName}</div>)}
                      </div>
                    </div>  
                    {/* {isEditing && ( */}
                      <div className="mb-3 row">
                        <label htmlFor="status" className="col-sm-4 col-form-label">Status :</label>
                        <div className="col-sm-6">
                          <select className="form-select" name="status" value={userDetails.status} onChange={handleInputChange}>
                            <option value="">Select</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                      </div>
                    {/* )}  */}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2 mt-4 mb-2">
                    {loading ? (
                      <div className='save-btn-with-loader'>
                        <button className="btn blue-btn mt-3 me-2">Save</button>
                        <div className="spinner-border text-primary mt-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ):(
                      <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmission}>Save</button>
                    )}
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>

      <AlertModal
          isOpen={isAlertModalOpen}
          onClose={() => handleCloseModal()}
          //={() => setIsAlertModalOpen(false)}
          title={alertMessage}
          error={alertError}
      />
    </div>
  )
}

export default UserForm;